import {combineReducers} from 'redux';

import {contractData} from './contract-data';
import {data} from './data';
import {overageStatus} from './overage-status';

import type {State as ContractDataState} from './contract-data';
import type {State as DataState} from './data';
import type {State as OverageState} from './overage-status';

export type State = {
    data: DataState,
    contractData: ContractDataState,
    overageStatus: OverageState,
};

export const limits = combineReducers({
    data,
    contractData,
    overageStatus,
});
